<template>
  <!--购买VIP-->
  <div id="buyvip">
    <h2 class="title">
      <router-link :to="{name: 'PersonInfo'}" class="prev"></router-link>
      教师资格会员
      <router-link to="RuleVip" class="rule">会员规则</router-link>
    </h2>
    <div class="profile">
      <span class="avatar" :style="{backgroundImage: 'url(' + this.$store.state.portrait + ')'}"></span>
      <div>
        <h3>{{this.$store.state.name}} <img :src="vipImageUrl" alt=""></h3>
        <p>当前{{vipName}}会员</p>
      </div>
    </div>
    <div class="ad-vip">
      <ul>
        <li @click="selectVip(item.vip_id, item.price)" :class="item.vip_id == payVipId ? 'active' : ''" v-for="(item, index) in vipListData" :key="index" :alt="item.vip_id">
          <h4>{{item.name}} <span></span></h4>
          <h5>¥<b>{{item.price}}</b></h5>
          <p>仅¥{{dayCost(item.price, item.company, item.time)}}/天</p>
        </li>
        <!--
        <li class="active">
          <h4>全年卡 366天 <span></span></h4>
          <h5>¥<b>279</b></h5>
          <p>仅¥69.8/季</p>
        </li>
        -->
      </ul>
    </div>
    <!--会员权益-->
    <div class="benefit">
      <h2>会员享受三大权益</h2>
      <ul>
        <li>
          <img src="../../assets/icon/personvip_icon_benefit1.png" alt="">
          <h5>考题视频解析</h5>
          <p>1500+考题精讲</p>
        </li>
        <li>
          <img src="../../assets/icon/personvip_icon_benefit2.png" alt="">
          <h5>名师经典课程</h5>
          <p>100+课程畅听</p>
        </li>
        <li>
          <img src="../../assets/icon/personvip_icon_benefit3.png" alt="">
          <h5>试卷考点分析</h5>
          <p>理解考题更深刻</p>
        </li>
      </ul>
    </div>
    <form action="/api/app/v1/post_order_immediate_payment" method="post" ref="buy">
      <input type="hidden" name="add_id" :value="0">
      <input type="hidden" name="shop_id" :value="this.payVipId">
      <input type="hidden" name="shop_type" :value="2">
      <input type="hidden" name="single_id" :value="0">
      <input type="hidden" name="vou_id" :value="0">
      <input type="hidden" name="payment_method" :value="this.payType">
      <input type="hidden" name="shop_courier_money" :value="0">
      <input type="hidden" name="shop_courier_name" :value="this.emsType">
      <input type="hidden" name="_sign" :value="submitSign">
    </form>
    <div class="coupon">
      <b>支付方式</b>
    </div>
    <!--微信-->
    <div class="wxpay">
      <label>
        <b>微信支付</b>
        <input type="radio" name="paytype" :value="1" v-model="payType" checked>
        <span></span>
      </label>
    </div>
    <!--支付宝-->
    <div class="alipay">
      <label>
        <b>支付宝支付</b>
        <input type="radio" name="paytype" :value="2" v-model="payType">
        <span></span>
      </label>
    </div>
    <div class="fix-bar">
      <b>¥{{parseInt(payPrice).toFixed(2)}}</b>
      <div class="discount">已优惠：¥29.00元</div>
      <a @click="submitPay" class="payfor">立即支付</a>
    </div>
    <i-login @listenShow="showLogin" v-show="loginShow"></i-login>
  </div>
</template>

<script>
import iLogin from '../share/popup/login/iLogin'
export default {
  name: 'BuyVip',
  data () {
    return {
      vipStatus: 0,
      vipName: '未开通',
      vipImageUrl: this.vipStatus === 0 ? require('../../assets/icon/personvip_icon_vip1.png') : require('../../assets/icon/personvip_icon_vip0.png'),
      vipListData: {},
      payVipId: 8,
      payPrice: 198.00,
      payType: 1,
      emsType: 'YTO',
      loginShow: 0
    }
  },
  components: {
    iLogin
  },
  mounted () {
    this.getIsVip()
    this.vipList()
  },
  methods: {
    getIsVip () {
      let data = {
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_user_opening_vip',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          console.log(res)
          if (res.data.errcode === 200) {
            this.vipStatus = res.data.data.status
            this.vipName = res.data.data.vip_name
            // this.vipImageUrl = res.data.data.image
          } else if (res.data.errcode === -1) {
            this.$store.dispatch('alterName', '')
            this.$store.dispatch('alterNickname', '')
            this.$store.dispatch('alterPortrait', '')
            this.$store.dispatch('alterSchool', '')
            this.$store.dispatch('alterToken', '')
            this.$store.dispatch('alterUid', '')
            this.$store.dispatch('alterVipname', '')
            this.$store.dispatch('alterViptime', '')
            this.loginShow = true
            // this.$router.push({name: 'PwdLogin', query: {backto: 'BuyVip'}})
          } else if (res.data.errcode === 400) {
            this.$store.dispatch('alterName', '')
            this.$store.dispatch('alterNickname', '')
            this.$store.dispatch('alterPortrait', '')
            this.$store.dispatch('alterSchool', '')
            this.$store.dispatch('alterToken', '')
            this.$store.dispatch('alterUid', '')
            this.$store.dispatch('alterVipname', '')
            this.$store.dispatch('alterViptime', '')
            this.loginShow = true
            // this.$router.push({name: 'PwdLogin', query: {backto: 'BuyVip'}})
          } else console.log(res.data.message)
        })
        .catch(err => {
          console.log(err)
        })
    },
    vipList () {
      let data = {
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_user_vip_list',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          console.log(res)
          if (res.data.errcode === 200) {
            this.vipListData = res.data.data
          } else alert(res.data.message)
        })
        .catch(err => {
          console.log(err)
        })
    },
    dayCost (price, unit, times) {
      let result = 0
      switch (unit) {
        case 'year':
          result = price / (365 * times)
          break
        case 'month':
          result = price / (30 * times)
          break
        case 'day':
          result = price / times
          break
        default:
          result = 0
          break
      }
      return result.toFixed(2)
    },
    selectVip (vipId, vipPrice) {
      this.payVipId = vipId
      this.payPrice = vipPrice
    },
    back () {
      if (window.history.length <= 1) {
        this.$router.push({path: '/'})
      } else {
        this.$router.go(-1)
      }
    },
    submitPay () {
      if (this.$store.state.uid === '' || this.$store.state.uid === undefined) {
        this.loginShow = true
        return false
      }
      this.$refs.buy.submit()
    },
    showLogin (isShow) {
      this.loginShow = isShow
    }
  },
  computed: {
    submitSign: function () {
      let data = {
        add_id: 0,
        shop_id: this.payVipId,
        shop_type: 2,
        single_id: 0,
        vou_id: 0,
        payment_method: this.payType,
        shop_courier_money: 0,
        shop_courier_name: this.emsType
      }
      return this.$encryption(data, this.$store.state.token, this.$store.state.uid)
    }
  }
}
</script>

<style scoped lang="stylus">
  #buyvip
    .title
      position: relative
      height: 1.08rem
      line-height: .8rem
      background-color: transparent
      padding: .14rem .16rem
      font-size: .32rem
      color: #050505
      font-weight: 600
      text-align: center
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      a.prev
        position: absolute
        top: .14rem
        left: .16rem
        display: block
        width: .8rem
        height: .8rem
        background-color: #fff
        -webkit-border-radius: 50%
        -moz-border-radius: 50%
        border-radius: 50%
        &::before
          content: ""
          position: absolute
          top: .3rem
          left: .32rem
          display: block
          width: .20rem
          height: .20rem
          border-left: .03rem solid #050505
          border-bottom: .03rem solid #050505
          -webkit-transform: rotate(45deg)
          -moz-transform: rotate(45deg)
          -ms-transform: rotate(45deg)
          -o-transform: rotate(45deg)
          transform: rotate(45deg)
      a.rule
        position: absolute
        top: .1rem
        right: .32rem
        font-size: .26rem
        color: #333
        font-weight: 500
    .profile
      display: flex
      justify-content: flex-start
      align-items: center
      width: 7.5rem
      height: 1.66rem
      border-top: .04rem solid #E7E8E9
      padding: .48rem .4rem .26rem
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      span.avatar
        display: block
        width: .92rem
        height: .92rem
        background: url(../../assets/img/personvip_img_avatar.png) no-repeat center
        -webkit-background-size: 100%
        background-size: 100%
        -webkit-border-radius: 50%
        -moz-border-radius: 50%
        border-radius: 50%
      h3
        margin-left: .32rem
        font-size: .32rem
        color: #333
        img
          position: relative
          top: .02rem
          left: .05rem
          width: .66rem
          height: .32rem
      p
        margin-left: .32rem
        font-size: .24rem
        color: #A3A9B7
    .ad-vip
      position: relative
      width: 6.7rem
      height: 2.32rem
      margin: 0 0 0 .4rem
      ul
        width: 7.1rem
        height: 2.1rem
        display: -webkit-box
        justify-content: flex-start
        align-items: center
        white-space: nowrap
        overflow-x: scroll
        overflow-y: hidden
        padding: 0 0 .2rem
        &::-webkit-scrollbar
          background-color: transparent
        li
          width: 2.84rem
          height: 2.1rem
          background-color: #F6F6F6
          padding: .26rem .16rem
          margin-right: .32rem
          -webkit-box-sizing: border-box
          -moz-box-sizing: border-box
          box-sizing: border-box
          h4
            display: flex
            justify-content: space-between
            align-items: center
            margin: .04rem 0
            font-size: .28rem
            color: #191919
            span
              display: block
              width: .32rem
              height: .32rem
              border: .02rem solid #A3A9B7
              -webkit-border-radius: 50%
              -moz-border-radius: 50%
              border-radius: 50%
          h5
            font-size: .28rem
            color: #191919
            b
              font-size: .4rem
          p
            width: 1.44rem
            height: .4rem
            line-height: .4rem
            background-color: transparent
            border: .02rem solid #A3A9B7
            margin-top: .08rem
            font-size: .24rem
            color: #191919
            text-align: center
            -webkit-border-radius: .2rem
            -moz-border-radius: .2rem
            border-radius: .2rem
          &.active
            background:linear-gradient(90deg,rgba(255,211,88,1) 0%,rgba(252,170,45,1) 100%)
            h4
              span
                position: relative
                background-color: #FFEBB4
                border-color: #FFEBB4
                &::before
                  content: ""
                  position: absolute
                  top: .07rem
                  left: .07 rem
                  display: block
                  width: .15rem
                  height: .09rem
                  border-left: .025rem solid #000
                  border-bottom: .025rem solid #000
                  -webkit-transform: rotate(-45deg)
                  -moz-transform: rotate(-45deg)
                  -ms-transform: rotate(-45deg)
                  -o-transform: rotate(-45deg)
                  transform: rotate(-45deg)

            p
              background-color: rgba(255,235,180,1)
              border-color: rgba(255,235,180,1)
    .benefit
      width: 7.5rem
      height: 3.02rem
      background-color: #fff
      border-top: .16rem solid #F9F9F9
      border-bottom: .16rem solid #F9F9F9
      margin-top: .28rem
      h2
        margin: .48rem 0 .28rem
        font-size: .32rem
        color: #333
        font-weight: 600
        text-align: center
      ul
        display: flex
        justify-content: space-around
        align-items: center
        li
          text-align: center
          img
            width: .44rem
            height: .52rem
          h5
            font-size: .26rem
            color: #333
          p
            font-size: .22rem
            color: #9DA4B3
  .coupon
    display: flex
    justify-content: space-between
    align-items: center
    height: .8rem
    line-height: .8rem
    background-color: #fff
    padding: 0 .4rem
    margin-top: .2rem
    border-bottom: .02rem solid #E7E8E9
    -webkit-box-sizing: border-box
    -moz-box-sizing: border-box
    box-sizing: border-box
    b
      font-size: .28rem
      color: #A3A9B7
      font-weight: 400
  .wxpay, .alipay
    width: 7.5rem
    height: 1rem
    background-color: #fff
    padding: 0 .4rem
    border-bottom: .02rem solid #E7E8E9
    -webkit-box-sizing: border-box
    -moz-box-sizing: border-box
    box-sizing: border-box
    label
      display: flex
      justify-content: space-between
      align-items: center
      height: 100%
      b
        font-size: .24rem
        color: #333
        &::before
          content: ""
          display: inline-block
          width: .4rem
          height: .4rem
          background: url(../../assets/icon/orderdetail_icon_weixin.png) no-repeat center
          -webkit-background-size: 100%
          background-size: 100%
          vertical-align: middle
          margin-right: .2rem
      input
        display: none
      span
        display: inline-block
        width: .4rem
        height: .4rem
        background: url(../../assets/icon/classall_icon_noselect.png) no-repeat center
        -webkit-background-size: 100%
        background-size: 100%
      input:checked + span
        background-image: url(../../assets/icon/classall_icon_tick.png)
  .alipay
    margin-bottom: .98rem
    label
      b
        &::before
          background-image: url(../../assets/icon/orderdetail_icon_zhifubao.png)
  .fix-bar
    position: fixed
    bottom: 0
    left: 50%
    display: flex
    justify-content: space-around
    align-items: center
    width: 7.5rem
    height: .98rem
    background-color: #fff
    padding: 0 .2rem
    -webkit-box-sizing: border-box
    -moz-box-sizing: border-box
    box-sizing: border-box
    -webkit-transform: translate(-50%, 0)
    -moz-transform: translate(-50%, 0)
    -ms-transform: translate(-50%, 0)
    -o-transform: translate(-50%, 0)
    transform: translate(-50%, 0)
    b
      font-size: .28rem
      color: #FF7052
    .discount
      visibility: hidden
      width: 2.68rem
      height: .98rem
      line-height: .98rem
      background-color: rgba(172,229,255,.12)
      font-size: .24rem
      color: #2BAAFF
      text-align: center
    a.payfor
      display: inline-block
      width: 2.4rem
      height: .72rem
      line-height: .72rem
      background:linear-gradient(90deg,rgba(255,211,88,1) 0%,rgba(252,171,46,1) 100%);
      /* background-color: rgba(255,112,82,0.7) */
      font-size: .32rem
      color: #fff
      text-align: center
      -webkit-border-radius: .49rem
      -moz-border-radius: .49rem
      border-radius: .49rem
</style>



// WEBPACK FOOTER //
// src/components/personal/BuyVip.vue